import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { ref: "screenRef" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, "Loading...", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, null, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_Suspense, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_router_view)
          ], 512)
        ]),
        fallback: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }))
    ]),
    _: 1
  }))
}